import { Atom } from "AppReact";
import styled, { css } from "styled-components";

const template = styled.div`
  ${({ displayState, theme }) => css`
    width: 108px;
    height: 108px;
    border-radius: 50%;
    display: ${displayState.hidden ? 'none' : 'flex'};
    align-items: center;
    justify-content: center;
    font-size: 32px;
    font-weight: 400;
    color: ${theme?.color?.secondary};
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })